import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    chatUserData: undefined
}

const cometChatSlice = createSlice({
    name: "Comet Chat",
    initialState: initialState,
    reducers: {
        setChatUserData: (state, actions) => {
            state.chatUserData = actions.payload
        }
    }
})


export const { setChatUserData } = cometChatSlice.actions

export default cometChatSlice.reducer